import { Time } from "@angular/common";
import { Menu, MenuItems } from "../shared/menu-items/menu-items";
import { Perfil } from "./perfil";
import { Sucursal } from "./sucursal";
import { Empresa } from "./empresa";
import { CobrosCobrador } from "./cobrosCobrador";
import { AdeudosUsuario } from "./adeudoUsuario";

export class Usuario {
    public nombre: string;
    public telefono: string;
    public correo: string;
    public diasLaborales: string;
    public horaInicio: Time;
    public horaFin: Time;
    public foto: string;
    public latitud: string;
    public longitud: string;
    public radio: number;
    public color: string;
    public fechaIngreso: Date;
    public activo: boolean;
    public modoOscuro: boolean;
    public perfil: Perfil;
    public sucursal: Sucursal;
    public empresa: Empresa;
    public menu: Menu[];
    public cobrosCobrador:CobrosCobrador[];
    public adeudos:AdeudosUsuario[];
    public connectionId:string;
    public tipoSistema:String;
    public boton:Boolean;
    public serial:String;
    public contratoBloqueado: boolean;
    public contratoEnPeriodoGracia: boolean;
    public mensajeContrato: string;
    public fechaLimiteGraciaContrato: Date;
    constructor() {
        this.nombre = "";
        this.correo = "";
        this.diasLaborales = "";
        this.telefono = "";
        this.horaInicio = null;
        this.horaFin = null;
        this.foto = "";
        this.latitud = "0";
        this.longitud = "0";
        this.radio = 0;
        this.color = "";
        this.fechaIngreso = new Date();
        this.activo = true;
        this.modoOscuro = false;
        this.perfil = new Perfil();
        this.sucursal = new Sucursal();
        this.empresa = new Empresa();
        this.menu = [];
        this.cobrosCobrador = [];
        this.adeudos = [];
        this.connectionId="";
        this.tipoSistema = "";
        this.boton = false;
        this.serial ="WEB";
        this.contratoBloqueado = false;
        this.contratoEnPeriodoGracia = false;
        this.mensajeContrato = "";
        this.fechaLimiteGraciaContrato = null;
    }
}





